<template>
    <v-container :class="outerContainer">
        <v-row  v-if="layout == 'PH5'  && item.columns.length == 4">
            <v-col v-for="(column, columnIndex) in item.columns"
                :key="columnIndex"
                :class="columnClass(column.styles.borderColor, column, columnIndex)"
                :cols="$vuetify.breakpoint.mdAndDown ? '12' : '6' "
                @click="selectedColumn({ element: index, column: columnIndex, styles: column.styles })"
                :style="[{
                    background: checkGridBg(column.styles, column),
                    border: `${column.styles.borderWidth}px solid ${column.styles.borderColor}`,
                    padding: `${column.styles.padding}px`,
                    margin: `${column.styles.margin}px`,
                    display: columnIndex % 2 == 0 ? '' : 'none',
                }]" >
               <div>
                    <div v-if="columnIndex % 2 == 0">
                    <v-row v-for="(colItem, colItemIndex) in column.data" :key="colItemIndex" class="mb-5">
                        <v-col cols="6" class="py-0">
                            <template v-if="colItem.type == 'textcard'">
                                <Textcard2 :item="colItem" :styles="styles.textcard" class="ph5-text"
                                    :indexes="{ element: index, column: columnIndex, data: colItemIndex }"
                                />
                            </template>
                        </v-col>
                        <v-col cols="6" class="py-0">
                            <span v-for="(column1, columnIndex1) in item.columns" :key="columnIndex1" >
                                <div v-for="(colItem1, colItemIndex1) in column1.data" :key="colItemIndex1"
                                :style="columnIndex1 == columnIndex + 1 && colItemIndex == colItemIndex1 ? 'height:100%': 'display:none'">
                                    <div v-if="columnIndex1 == columnIndex + 1 && colItemIndex == colItemIndex1" style="height:100%">
                                        <template v-if="colItem.type == 'textcard'">
                                            <Textcard2 :item="colItem1" :styles="{ outlined: true, elevation: 0, card: 'ph5-outlined-card pa-3 d-flex justify-center align-center',
                                                                text: 'body montserrat-bold text-center d-flex align-center justify-center',
                                                                }"
                                                :indexes="{ element: index, column: columnIndex1, data: colItemIndex1 }"
                                            />
                                        </template>
                                    </div>
                                </div>
                            </span>
                        </v-col>
                    </v-row>
                  </div>
               </div>
            </v-col>
        </v-row>
        <v-row v-else>
            <v-col v-for="(column, columnIndex) in item.columns"
                :key="columnIndex"
                :class="columnClass(column.styles.borderColor, column, columnIndex)"
                :cols="$vuetify.breakpoint.mdAndDown ? mobileColumnCount(item.columns.length) : columnCount(item.columns.length)"
                @click="selectedColumn({ element: index, column: columnIndex, styles: column.styles })"
                :style="{
                    background: checkGridBg(column.styles, column),
                    border: `${column.styles.borderWidth}px solid ${column.styles.borderColor}`,
                    padding: `${column.styles.padding}px`,
                    margin: `${column.styles.margin}px`,
                }"
            >
                <div v-for="(colItem, colItemIndex) in column.data" :key="colItemIndex" :class="colItemContainerClass(colItem, column.data)">
                    <template v-if="colItem.type == 'text'">
                        <p class="responsive-text" :class="adjustedTextClass(styles.text, column.styles.textAlignment)"
                            :style="{ color: column.styles.textColor}"
                            @focusout="columnEditableData('text', { element: index, column: columnIndex, data: colItemIndex })" :contenteditable="editableContent"
                            @paste="filterPastedContent"
                            v-html='layout == "FTDescription" ? colItem.text : colItem.text.replace(/font-size: [^;]+;/g, "")'
                            ref="text"
                            :id="`${index}-${columnIndex}-${colItemIndex}`"
                        >
                        </p>
                    </template>
                    <template v-if="['heading1', 'heading2'].includes(colItem.type)">
                        <HeadingElem2 :item="colItem" :styles="styles[colItem.type]"
                            :gridHeadingColor="column.styles.headingColor"
                            :indexes="{ element: index, column: columnIndex, data: colItemIndex }"
                        />
                    </template>

                    <template v-if="colItem.type == 'image'">
                        <ImageElement :item="colItem" :styles="styles.image"
                            :indexes="{ element: index, column: columnIndex, data: colItemIndex }"
                        />
                    </template>

                    <template v-if="colItem.type == 'dialog'">
                        <Dialog2 :item="colItem" :styles="styles.dialog"
                            :indexes="{ element: index, column: columnIndex, data: colItemIndex }"
                        />
                    </template>

                    <template v-if="colItem.type == 'textcard'">
                        <Textcard2 :item="colItem" :styles="styles.textcard"
                            :indexes="{ element: index, column: columnIndex, data: colItemIndex }"
                        />
                    </template>

                    <template v-if="colItem.type == 'imagecard'">
                        <Imagecard2 :item="colItem" :styles="styles.imagecard"
                            :indexes="{ element: index, column: columnIndex, data: colItemIndex }"
                            @uploadImage="uploadImage({ element: index, column: columnIndex, data: colItemIndex }, 'imagecard')"
                        />
                    </template>

                    <template v-else-if="colItem.type == 'imagecard2'">
                        <ImagecardV2 :item="colItem" :styles="styles.imagecard2"
                            :indexes="{ element: index, column: columnIndex, data: colItemIndex }"
                            @uploadImage="uploadImage({ element: index, column: columnIndex, data: colItemIndex }, 'imagecard')"
                        />
                    </template>

                    <template v-if="colItem.type == 'dropdown'">
                        <Dropdown :item="colItem" :styles="styles.dropdown"
                            :indexes="{ element: index, column: columnIndex, data: colItemIndex }"
                            @uploadImage="uploadImage({ element: index, column: columnIndex, data: colItemIndex }, 'dropdown')"
                        />
                    </template>
                </div>
                <!-- for deleting data from column  -->
                <div v-if="pageType == 'Canvas'" class="text-center mt-5">
                    <v-btn small dense color="error" class="mr-1" @click="removeDataFromColumn({ element: index, column: columnIndex })">Remove Last</v-btn>
                </div>
            </v-col>
        </v-row>
        <RowControls v-if="pageType == 'Canvas'" :rowIndex="index" />
    </v-container>
</template>

<script>
import RowControls from "@/components/RowControls.vue"
import Textcard2 from "@/components/elements/Textcard2"
import Imagecard2 from "@/components/elements/Imagecard2"
import ImagecardV2 from "@/components/elements/ImagecardV2"
import Dialog2 from "@/components/elements/Dialog2"
import Dropdown from "@/components/elements/Dropdown"
import HeadingElem2 from "@/components/elements/HeadingElem2"
import ImageElement from "@/components/elements/ImageElem"
import { bus } from "@/main"

export default {
    props: ["item", "index", "styles"],
    components: { RowControls, Textcard2, Imagecard2, ImagecardV2, Dialog2, Dropdown, HeadingElem2, ImageElement },
    data () {
        return {
            isFTDescTitle: false
        }
    },

    beforeMount () {
        if (this.layout == "IELTS1" && this.pageType == "Preview" && this.$vuetify.breakpoint.mdAndDown) {
            const item = this.item.columns
            if (item[0].data[0].type == "text" && item[1].data[0].type == "image") {
                this.swapContent(0, 1)
                this.swapContent(2, 3)
            }
        }
    },

    mounted () {
        if (this.layout == "FTDescription") {
            // get ref text
            const refText = this.$refs.text
            // loop through childNodes of refText
            if (refText) {
                for (let i = 0; i < refText[0].childNodes.length; i++) {
                    // add display inline block if childNode is a span
                    if (refText[0].childNodes[i].nodeName == "SPAN") {
                        refText[0].childNodes[i].style.display = "inline-block"
                    }
                }
            }
            this.isFTDescTitle = this.item.columns.length == 2
        }
    },

    beforeUpdate () {
        if (this.layout == "IELTS1" && this.pageType == "Preview" && this.index == 3) {
            const item = this.item.columns
            if (this.$vuetify.breakpoint.mdAndDown) {
                if (item[0].data[0].type == "text" && item[1].data[0].type == "image") {
                    this.swapContent(0, 1)
                    this.swapContent(2, 3)
                }
            }
            else {
                if (item[0].data[0].type == "image" && item[1].data[0].type == "text") {
                    this.swapContent(0, 1)
                    this.swapContent(2, 3)
                }
            }
        }
    },
    methods:
    {
        // computed
        // this is responsible for canvas' row borders
        columnClass (color, column, columnIndex) {
            let customizedClass

            if (["PRT1", "IE", "Milestone1", "BESD2", "FSIC1", "PPJB", "PPJI", "PPJA", "PH1", "PH2", "PH3", "PH4", "PH6", "HD1", "GME", "BD1", "CJB2"].includes(this.layout)) {
                customizedClass = "py-0"
            }

            if (this.layout == "FTDescription" && column.data.length > 0 && this.isFTDescTitle) {
                customizedClass = (column.data[0].type == "text") ? "d-flex align-center justify-center" : ""
            }

            if (this.layout == "FSIC1" && column.styles.background == "#d8dcfc") {
                customizedClass = "mb-5"
            }

            if (this.pageType == "Canvas") {
                return color.length ? `bordered-cols active-border ${customizedClass}` : `bordered-cols ${customizedClass}`
            }

            else if (this.pageType == "Preview") {
                return customizedClass
            }
        },

        colItemContainerClass (item, columnData) {
            if (this.layout == "FSIC1") {
                return columnData.length == 1 && item.type == "textcard" ? "fill-height pt-5" : ""
            }

            if (this.layout == "BPM") {
                return item.type == "textcard" && this.item.columns.length != 1 ? "fill-height" : ""
            }
        },

        checkGridBg (styles, column) {
            const defaultColors = ["", "#ffffff", "#000000"]
            // checks if 2 gradient bgs have user selected color

            if (!defaultColors.includes(styles.gradientBg1) && !defaultColors.includes(styles.gradientBg2)) {
                return `linear-gradient(to right top, ${styles.gradientBg1}, ${styles.gradientBg2})`
            }
            else if (this.layout == "IE" && this.$vuetify.breakpoint.smAndDown && column.data.length > 0) {
                if (column.data[0].text.includes(">A</b>")) {
                    return "linear-gradient(to right,  #ffecd4 0%,#ffecd4 50%,#e0bcac 50%,#e0bcac 100%)"
                }
                if (column.data[0].text.includes(">B</b>")) {
                    return "linear-gradient(to right,  #ffecd4 0%,#ffecd4 50%,#e0bcac 50%,#e0bcac 100%)"
                }
            }
            else {
                return styles.background
            }
        },

        adjustedTextClass (className, alignment) {
            if (["IE", "BPE", "BPP", "BPM"].includes(this.layout)) {
                return this.$vuetify.breakpoint.mdAndUp ? `${className} ${alignment}` : `${className} text-center`
            }
            else {
                return `${className} ${alignment}`
            }
        },

        columnCount (length) {
            if (length == 1) return "12"
            else if (length == 2) return "6"
            else if (length == 3) return "4"
            else if (length == 4) return "3"
        },

        mobileColumnCount (length) {
            if (this.layout == "GIPB") {
                return length == 2 ? "" : "12"
            }
            return "12"
        },

        uploadImage (data, type) {
            bus.$emit("uploadImage", { indexes: data, type })
        },

        selectedColumn (data) {
            bus.$emit("clickedColumn", data.styles)
            bus.$emit("columnForBorder", data)
        },

        swapContent (index1, index2) {
            [this.item.columns[index1], this.item.columns[index2]] = [this.item.columns[index2], this.item.columns[index1]]
        }

    }
}
</script>

<style scoped>

.image {
    margin: 0 auto !important;
}

.bordered-cols:hover {
    border: 2px solid rgb(78, 206, 78) !important;
    transition: all 0.3s ease-in-out;
}

.ie-image-card > div {
    height: 100%;
}

.ie-image-card > div > div{
    height: 100%;
}

.responsive-text {
    font-size: min(4vw, 1.2rem);
}

.wrap-overflow {
    overflow-wrap: break-word !important;
}

.besd-text {
    font-size: min(4vw, 1.2em)
}

.ph5-text{
    background-color: #f6edd9;
}

.ph5-textcard > div {
    background-color: #f6edd9;
}

</style>
